/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * BaseTen.web.tsx - Shows a number in base 10 with blocks.
 */

import { hintImages } from '../HintImages';
import './BaseTen.web.css';


import type { JSX } from 'react';


interface BaseTenProps {
  tens: number;
  ones: number;
}

const BaseTen = (props: BaseTenProps) => {
  const tens: JSX.Element[] = [];
  const ones: JSX.Element[] = [];

  for (let i = 0; i < props.tens; i++) {
    const imageSource = 'yellow1';
    tens.push(
      <img className="base_ten_image" src={hintImages[imageSource].uri} key={'yellow-block'+i} />
    );
  }

  const numAOnes = props.ones;
  let numAOnesLeft;
  let numAOnesRight;
  if (numAOnes > 5) {
    numAOnesLeft = 5;
    numAOnesRight = numAOnes - numAOnesLeft;
    let imageSource = `red${numAOnesLeft.toString()}`;
    ones.push(
      <img className="base_ten_image" src={hintImages[imageSource].uri} key={'reds_less_5'}/>
    );
    imageSource = `red${numAOnesRight.toString()}`;
    ones.push(
      <img className="base_ten_image" src={hintImages[imageSource].uri} key={'reds_more_5'}/>
    );
  } else if (numAOnes !== 0) {
    const imageSource = `red${numAOnes.toString()}`;
    ones.push(
      <img className="base_ten_image" src={hintImages[imageSource].uri} key={'reds'} />
    );
  }

  return (
    <div id="hint_base_ten">
      {tens.length !== 0
        && (
          <div className="base_ten_tens">
            {tens}
          </div>
        )}
      {ones.length !== 0
        && (
          <div className="base_ten_ones">
            {ones}
          </div>
        )}
    </div>
  );
};

export default BaseTen;
